export var ThemeType;
(function (ThemeType) {
    ThemeType[ThemeType["SYSTEM"] = 0] = "SYSTEM";
    ThemeType[ThemeType["LIGHT"] = 1] = "LIGHT";
    ThemeType[ThemeType["DARK"] = 2] = "DARK";
})(ThemeType || (ThemeType = {}));
export var EffectiveThemeType;
(function (EffectiveThemeType) {
    EffectiveThemeType[EffectiveThemeType["LIGHT"] = 0] = "LIGHT";
    EffectiveThemeType[EffectiveThemeType["DARK"] = 1] = "DARK";
})(EffectiveThemeType || (EffectiveThemeType = {}));
export const themeTypeTranslator = {
    [ThemeType.SYSTEM]: 'Системная',
    [ThemeType.LIGHT]: 'Светлая',
    [ThemeType.DARK]: 'Тёмная',
};
